import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { usePageMetadata } from "../context/PageMetadataContext";
import { PiscanAPI } from "../api/piscan";
import { useLanguage } from "../context/LanguageContext";

const ContactUs: React.FC = () => {
  const { t } = useLanguage();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const {setHeading, setTitle, setDescription} = usePageMetadata();
  
  useEffect(() => {
    setHeading(t('contact.heading'));
    setTitle(t('contact.title'));
    setDescription(t('contact.description'));
  }, [setTitle, setDescription, setHeading, t]);
  
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    try {
      const response = await fetch(PiscanAPI.Contact, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
  
      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }
      
      console.log("Form Submitted Successfully:", formData);
    } catch (error) {
      console.error("Failed to submit the form:", error);
    }
  };

  return (
    <div className="white-zone content-page">
      <div className="container py-5">
        <div className="row">
          <div className="col-md-3"></div>
          <div className="col-md-6 col-sm-12">
            <h1 className="mb-4">{t('contact.heading')}</h1>
            <p>
              {t('contact.intro_text')}{" "}
              <a href="mailto:contact@piscan.io" className="text-primary">contact@piscan.io</a>
            </p>

            {submitted ? (
              <div className="alert alert-success" role="alert">
                {t('contact.success_message')}
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="mt-4">
                <div className="mb-3">
                  <label htmlFor="name" className="form-label">{t('contact.form.name')}</label>
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="email" className="form-label">{t('contact.form.email')}</label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="message" className="form-label">{t('contact.form.message')}</label>
                  <textarea
                    className="form-control"
                    id="message"
                    name="message"
                    rows={4}
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>

                <button type="submit" className="btn btn-primary">{t('contact.form.submit')}</button>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
